import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';

import styles from './epstEvaluation.module.scss';

const WritingQuestion = ({ questionData, onScoreChange }) => {
	const { question, points, answer, question_id } = questionData;

	const [score, setScore] = useState(0);
	const [earnedPoints, setEarnedPoints] = useState(0);

	const wordCount = answer ? answer.trim().split(/\s+/).length : 0;

	const handleScoreChange = (e) => {
		const value = parseInt(e.target.value, 10);
		if ((value >= 0 && value <= 100) || isNaN(value)) setScore(e.target.value);
	};

	useEffect(() => {
		const calculated = score ? Math.round((score * points) / 100) : 0;
		setEarnedPoints(calculated);
		onScoreChange(question_id, score, calculated);
	}, [score]);

	return (
		<div className={styles.container}>
			<p className={styles.questionText}><strong>{question}</strong></p>
			<textarea
				className={styles.answerBox}
				rows={6}
				value={answer || 'No answer submitted'}
				readOnly
			/>
			<div className="text-end mt-1">
				<span style={{ fontSize: '0.85rem', color: '#666' }}>
					{answer?.trim().split(/\s+/).filter(Boolean).length || 0} words
				</span>
			</div>
			<Row className="justify-content-center text-center">
				<Col xs={12} md={4}>
					<p><strong>Puntos:</strong> {points}</p>
					<p><strong>Total obtenidos:</strong> {earnedPoints}</p>
				</Col>
				<Col xs={12} md={4}>
					<label><strong>Calificación (1 - 100):</strong></label>
					<input
						type="number"
						value={score}
						onChange={handleScoreChange}
						min="1"
						max="100"
						className={`${styles.scoreInput} form-control mx-auto`}
						style={{ maxWidth: '200px', textAlign: 'center' }}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default WritingQuestion;